// removed by extract-text-webpack-plugin
module.exports = {"component":"NdGxTHfCtmQ0Y2S5NlDCh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Price/price.css
// module id = 1111
// module chunks = 2